/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Billing period
 */
export const ProductBillingPeriod = {
  EveryMonth: "every-month",
  EveryThreeMonths: "every-three-months",
  EverySixMonths: "every-six-months",
  EveryYear: "every-year",
  Once: "once",
} as const;
/**
 * Billing period
 */
export type ProductBillingPeriod = ClosedEnum<typeof ProductBillingPeriod>;

/** @internal */
export const ProductBillingPeriod$inboundSchema: z.ZodNativeEnum<
  typeof ProductBillingPeriod
> = z.nativeEnum(ProductBillingPeriod);
/** @internal */
export const ProductBillingPeriod$outboundSchema: z.ZodNativeEnum<
  typeof ProductBillingPeriod
> = ProductBillingPeriod$inboundSchema;
